import dayjs from 'dayjs';

import { useNavigate } from 'hooks';
import { ListCardStyle } from 'types';
import { Flex } from 'components/flex';
import {
  PersonalNotification,
  useMarkPersonalReadMutation,
} from 'store/api/notifications';

import * as Styles from './styles';

// PAYOUT SENT (owner, 26 Oct 2026; plan PUSH-PAYOUT-SENT-ADDENDUM.md §4): an
// alert for the signed-in person only. No amount here: the bell also shows on
// shared selling iPads. A tap marks it read and opens its page (Payments).
export const PersonalNotificationCard = ({
  close,
  showDivider,
  notification,
}: {
  close: () => void;
  showDivider?: boolean;
  notification: PersonalNotification;
}) => {
  const navigate = useNavigate();
  const [markRead] = useMarkPersonalReadMutation();
  const userTimezone = dayjs.tz.guess();

  const open = () => {
    if (!notification.readAt) {
      markRead(notification.id);
    }
    if (notification.link) {
      close();
      navigate(notification.link);
    }
  };

  return (
    <Styles.StyledListCard
      isOdd
      padding="16px"
      onClick={open}
      template="minmax(0, 1fr)"
      showDivider={showDivider}
      odd={ListCardStyle.Default}
      mobileTemplate="minmax(0, 1fr)"
      tabletTemplate="minmax(0, 1fr)"
      data-testid="personal-notification-card"
      values={[
        <Flex column gap={8}>
          <Flex gap={8} alignItems="center">
            {!notification.readAt && <Styles.UnreadDot />}
            <Styles.Title title={notification.title}>
              {notification.title}
            </Styles.Title>
          </Flex>
          <Styles.Message>{notification.text}</Styles.Message>
          <Styles.Time>
            {dayjs(notification.createdAt).tz(userTimezone).fromNow()}
          </Styles.Time>
        </Flex>,
      ]}
    />
  );
};
